import { render, staticRenderFns } from "./NoData.vue?vue&type=template&id=4af5db8c&scoped=true&"
import script from "./NoData.vue?vue&type=script&lang=ts&"
export * from "./NoData.vue?vue&type=script&lang=ts&"
import style0 from "./NoData.vue?vue&type=style&index=0&id=4af5db8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af5db8c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VRow})
